import Modal from 'modules/Modal';

export default class NeedSignupPromptModal {
  constructor() {
    this.initialize();
  }

  initialize() {
    new Vue({
      el: '#need-signup-prompt',
      name: 'NeedSignupPromptModal',
      data() {
        return {
          modal: new Modal(),
          value: null,
          modalId: '#need-signup-prompt',
        };
      },
      mounted() {
        window.EventBus.$on('need-signup-prompt', this.modalOpen);
      },
      methods: {
        modalOpen(value) {
          this.value = value;
          this.modal.open(this.modalId);
        },
      },
    });
  }
}
